import { inject, ref, reactive, onActivated, onDeactivated } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { routerPush } from '@/router';
import { PASSWORD_RESET } from "@/store/actions.type";
export default {
  name: 'PasswordReset',

  setup() {
    const store = useStore();
    const route = useRoute();
    const logger = inject('logger');
    const componentState = reactive({
      isLoading: false,
      isRendered: false
    });
    onActivated(() => {
      componentState.isRendered = true;
    });
    onDeactivated(() => {
      componentState.isRendered = false;
    });
    const formState = reactive({
      isFormDone: false,
      isHashValid: false
    });
    const validationRules = {
      password: [{
        required: true,
        message: "Hasło jest wymagane",
        trigger: "blur"
      }, {
        min: 6,
        message: "Hasło musi posiadać przynajmniej 6 znaków",
        trigger: "blur"
      }, {
        max: 128,
        message: "Hasło może posiadać maksymalnie 128 znaków",
        trigger: "blur"
      }],
      password_confirmation: [{
        validator: (rule, value, callback) => {
          if (value === '') callback(new Error('Wprowadź ponownie hasło'));else if (value !== credentials.password) callback(new Error("Podane hasła nie zgadzają się"));else callback();
        },
        trigger: "blur"
      }]
    };
    const credentialsForm = ref();
    const credentials = reactive({
      hash: route.params.hash,
      password: '',
      password_confirmation: ''
    });

    function validateCredentials() {
      credentialsForm.value.validate(valid => {
        if (!valid) return;
        recoverPassword();
      });
    }

    function recoverPassword() {
      componentState.isLoading = true;
      store.dispatch(PASSWORD_RESET, credentials).then(() => formState.isFormDone = true).catch(error => logger(error, error)).finally(() => componentState.isLoading = false);
    }

    return {
      componentState,
      formState,
      validationRules,
      credentialsForm,
      credentials,
      validateCredentials,
      routerPush
    };
  }

};